import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { urls } from "../configs/serviceConfig";
import { authorizationHeaders } from "./authorizationHeaders";

export const profileApiV2 = createApi({
  reducerPath: "profileApiV2",
  baseQuery: fetchBaseQuery({
    baseUrl: `${urls.profileService}/v2/profile`,
    prepareHeaders: authorizationHeaders,
  }),

  endpoints: builder => ({
    addJourneyToProfile: builder.mutation<void, { userId: string; referralCode: string }>({
      query({ userId, referralCode }) {
        return {
          url: `/${userId}/journey`,
          method: "POST",
          body: { ReferralCode: referralCode },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAddJourneyToProfileMutation } = profileApiV2;
